/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Jobs_DescriptionInputs */

const en_candidate_jobs_description = /** @type {(inputs: Candidate_Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here are the jobs that match your profile.`)
};

const de_candidate_jobs_description = /** @type {(inputs: Candidate_Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier sind die Jobs, die zu Ihrem Profil passen.`)
};

/**
* | output |
* | --- |
* | "Here are the jobs that match your profile." |
*
* @param {Candidate_Jobs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_jobs_description = /** @type {((inputs?: Candidate_Jobs_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Jobs_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_jobs_description(inputs)
	return en_candidate_jobs_description(inputs)
});